var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"uk-button uk-button-small uk-button-primary",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.refresh}},[_c('i',{staticClass:"material-icons"},[_vm._v("refresh")]),_vm._v(" "),(_vm.loading)?_c('span',[_vm._v("갱신중...")]):_c('span',[_vm._v("제한상태 갱신")])])
}
var staticRenderFns = []

export { render, staticRenderFns }